import React from 'react';
import { Spin } from 'antd';
const Loader = () => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: 'tranparent',
			}}
		>
			<Spin size="large" />
		</div>
	);
};
export default Loader;
